module.exports = __webpack_public_path__ + "img/ueberblick_de.c8f6bb60.jpg";